import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useSelector} from "react-redux";
import { Link } from "react-router-dom";
import { CardBody,Progress, Spinner } from "reactstrap";
import SolidButton from "../componentes/buttons/SolidButton";
import server from "../config/server";
import {Animated} from "react-animated-css";
import LinearProgress from '@material-ui/core/LinearProgress';
import { useDispatch } from "react-redux";
import { fetchProducts } from "../action/FutbolistaActions";
import General from "../componentes/modals/General";
import TodosEncuentros from "../componentes/modals/TodosEncuentros";


const GraficosVotaciones = React.memo((props) => {
  const [calificaciones, setCalificaciones] = useState([]);
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;
  
  // Memoizar configuración del servidor
  const config_server = useMemo(() => {
    return JSON.parse(localStorage.getItem("configServer"));
  }, []);

  // Memoizar idCalificador
  const idCalificador = useMemo(() => {
    const stored = localStorage.getItem("idCalificador");
    return stored === "undefined" ? [] : JSON.parse(stored);
  }, []);

  // Memoizar API URL
  const API = useMemo(() => {
    return server.baseURL + `catalogos/votaciones/list/${idCalificador}`;
  }, [idCalificador]);

  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;
    
    fetch(API, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (isMounted && data.data) {
          setCalificaciones(data.data);
        }
      })
      .catch((error) => {
        // Eliminado console.log para mejor rendimiento
        if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
          console.error('Error fetching calificaciones:', error);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [API]);

  // Función memoizada para determinar color
  const getColorByPercentage = useCallback((porcentaje) => {
    switch (true) {
      case porcentaje >= 0 && porcentaje <= 49:
        return 'warning';
      case porcentaje >= 50 && porcentaje <= 79:
        return 'primary';
      case porcentaje >= 80 && porcentaje <= 100:
        return 'success';
      default:
        return 'warning';
    }
  }, []);

  // Memoizar la renderización de calificaciones
  const renderCalificacion = useCallback((obj) => {
    return obj.map((cal) => {
      const calificacion = parseInt(cal.promedio);
      const porcentaje = parseInt(cal.porcentaje);
      const auto = cal.nombre_auto;
      const puntos = cal.votos;
      const participantes = cal.cantidad;
      const imagen = cal.imagen_auto !== "" ? cal.imagen_auto : "/fans/boy1-sm.png";
      const id = cal.id_auto;
      const color = getColorByPercentage(porcentaje);

      return (
        <li className="mb-4 glass" key={id}>
          <Animated animationIn="flipInY" animationOut="flipOutY" animationInDuration={3000} animationOutDuration={3000} isVisible={true}>
            <div className="d-flex align-items-center">
              <small style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img 
                    className="camiseta" 
                    src={`${config_server.linkImageAuto}${imagen}`} 
                    alt={auto}
                    loading="lazy"
                  />
                </div>
                <div>
                  <h2 className="color-white">{auto}</h2>
                  <h5 style={{ color: "white", marginLeft: "1rem" }}>
                    Puntos: {puntos} - Participantes: {participantes}
                  </h5>
                </div>
              </small>
              <div className="ml-auto">
                <h2 className="h1-1">{calificacion}</h2>
              </div>
            </div>
            <Progress 
              width="500px"
              height="10px" 
              value={porcentaje} 
              animated 
              color={color}
            />
          </Animated>
        </li>
      );
    });
  }, [config_server.linkImageAuto, getColorByPercentage]);

  // Memoizar contenido renderizado
  const renderedContent = useMemo(() => {
    if (calificaciones.length === 0) {
      return <div />;
    }
    return (
      <ul className="list-style-none country-state mt-4" style={{ marginLeft: "-4rem" }}>
        {renderCalificacion(calificaciones)}
      </ul>
    );
  }, [calificaciones, renderCalificacion]);

  return (
    <React.Fragment>
      <section className="container-gr">
        <div className="container-azul2">
          <div className="cab-verde" >
            <h1 className="h1-1 centrar">Calificaciones <General/></h1>
            

          </div>
          <div className="container-azul">
            <CardBody>
              <div className="">
                <div>
                  
                  {renderedContent}
                 
                </div>
              </div>
              
            </CardBody>

          </div>
          
        </div>
      </section>
    </React.Fragment>
  );
});

GraficosVotaciones.displayName = 'GraficosVotaciones';

export default GraficosVotaciones;

